<ng-container *ngIf="ctx" [ngSwitch]="ctx.HomeScreen">
    <app-home-default [ctx]="ctx" *ngSwitchDefault></app-home-default>
    <app-home-pro-parts [ctx]="ctx" [ctxPromotions]="ctxPromotions" [ctxLoyaltyShop]="ctxLoyaltyShop" *ngSwitchCase="'proparts'"></app-home-pro-parts>
    <app-home-hofland [ctx]="ctx" [ctxPromotions]="ctxPromotions" [ctxLoyaltyShop]="ctxLoyaltyShop" *ngSwitchCase="'hofland'"></app-home-hofland>
    <app-home-star [ctx]="ctx" [ctxPromotions]="ctxPromotions" [ctxLoyaltyShop]="ctxLoyaltyShop" *ngSwitchCase="'star'"></app-home-star>
    <app-home-excluparts *ngSwitchCase="'excluparts'"></app-home-excluparts>
    <app-home-rijpma  *ngSwitchCase="'rijpma'"></app-home-rijpma>
    <app-home-webshop [ctx]="ctx" *ngSwitchCase="'webshop'"></app-home-webshop>
</ng-container>